import * as yup from 'yup';

const creativeSchema = yup.object().shape({
  id: yup.string().required(),
  creative_id: yup.string().required(),
  creative_type: yup.string().oneOf(['video', 'image']).required(),
  name: yup.string().required(),
});

const lineItemSchema = yup.object().shape({
  account_id: yup.string().required(),
  campaign_id: yup.string().required(),
  campaign_name: yup.string().required(),
  line_item_id: yup.string().required(),
  line_item_name: yup.string().required(),
  flow: yup.string().required('Line item has no flow'),
});

export const createTwitterAdSchema = yup
  .object()
  .shape({
    app: yup.string().required('App is required').trim().min(1),
    creatives: yup
      .array()
      .of(creativeSchema)
      .required('Creatives are required')
      .min(1, 'At least one creative must be selected'),
    line_items: yup
      .array()
      .of(lineItemSchema)
      .required('Ad groups are required')
      .min(1, 'At least one ad group must be selected'),
    ad_settings: yup
      .mixed<Record<string, { text_id: string; locale: string }>>()
      .required('Ad settings are required'),
  })
  .test('flows-have-settings', 'Every selected ad group flow needs ad settings', function (value) {
    const missing = (value.line_items ?? []).find((lineItem) => {
      const setting = value.ad_settings?.[lineItem.flow];
      return !setting?.text_id || !setting.locale;
    });

    if (!missing) return true;

    return this.createError({
      path: 'ad_settings',
      message: `No ad settings for flow ${missing.flow}`,
    });
  });

export type ValidatedCreateTwitterAdParams = yup.InferType<typeof createTwitterAdSchema>;
